import {
  Tooltip,
} from '@speaking-coach/ui'

export function ColumnFilterDot(): JSX.Element {
  return (
    <sup aria-hidden className="relative -top-1 ml-1 inline-block align-super leading-none">
      <span className="inline-block size-1.5 rounded-full bg-text-primary" />
    </sup>
  )
}

/** A filter marker independent of the column's sort control. */
export function ColumnFilterIndicator({
  column,
  description,
}: {
  column: string
  description?: string
}): JSX.Element | null {
  if (!description) return null
  const label = `${column} filter: ${description}`
  return (
    <span role="img" aria-label={label} className="inline-block">
      <ColumnFilterDot />
    </span>
  )
}

/** A non-sortable header with the same filter affordance as SortableTh. */
export function FilterTh({
  label,
  filterDescription,
  className = 'p-3 font-medium',
  title,
}: {
  label: string
  filterDescription?: string
  className?: string
  title?: string
}): JSX.Element {
  const heading = (
    <th
      aria-label={filterDescription ? `${label} (filtered)` : undefined}
      aria-description={filterDescription || undefined}
      tabIndex={filterDescription ? 0 : undefined}
      className={`${className} focus-visible:focus-ring-inset`}
      title={filterDescription ? undefined : title}
    >
      {label}
      {filterDescription && <ColumnFilterIndicator column={label} description={filterDescription} />}
    </th>
  )
  return filterDescription
    ? <Tooltip align="start" alignOffset={12} arrow="start" label={`${label} filter: ${filterDescription}`}>{heading}</Tooltip>
    : heading
}

export function describeColumnFilters(...constraints: Array<string | false | undefined>): string {
  return constraints.filter(Boolean).join('; ')
}
